module.exports = __webpack_public_path__ + "img/study_content_bigbg.20c5276d.png";